// 渠道预订详情
import { ClientType, MemberLevel } from '@/config/constant';
import { CRSReserveDetailAction } from '@/redux/actions/reservation/constant';
import { RentTimeInfo, RemarkInfo } from './base.d';

// 预订人信息
interface CustomerInfo {
  name: string;
  mobile: string;
  certNo: string;
  memberLevel: MemberLevel;
}

// 渠道信息
interface ChannelInfo {
  channelName: string; // 客源渠道名称
  strategyName: string; // 计价策略名称
  clientName: ClientType; // 客户端名称
  channelOrderNo: string; // 渠道单号
  paymentAmount: string; // 应付金额
  actualPayAmount: number; // 实付金额
  pointsValue: number; // 积分
  pointsDeduction: number; // 积分抵扣
  orderCreateTime: string; // 下单时间
  orderCancelTime: string; // 订单取消时间
}

// 入住信息
interface RentBaseInfo extends RentTimeInfo {
  roomTypeName: string; // 房型
  roomNum: number; // 房间数
}

// 入住房间信息
export interface RentRoomInfo {
  indexId: string;
  rowSpan: number; // 日期占用行数
  rentDate: string; // 入住日期 按营业日
  roomNo: string; // 房号(房间1、2)
  roomPrice: string; // 房间单价
  couponAmount: string; // 优惠券金额
  couponNo: string; // 优惠券编号
  commission: string; // 使用费
  executePrice: string; // 执行房价
}

export interface MainState {
  channelInfo: ChannelInfo; // 客源渠道
  customerInfo: CustomerInfo; // 预订人信息
  rentBaseInfo: RentBaseInfo; // 入住信息
  remarkInfo: RemarkInfo; // 备注
  rentRoomInfos: RentRoomInfo[];
}

export interface ReducerState extends MainState {
  isInit: boolean; // 初始化
  isLoading: boolean; // 加载中
}

const initialState: Partial<ReducerState> = {
  isInit: false,
  isLoading: true,
};

type ActionHandler<T> = (state: ReducerState, action: { payload: T }) => ReducerState;

const reducerMap = {
  [CRSReserveDetailAction.initDefaultState]: <ActionHandler<Partial<ReducerState>>>((
    state,
    { payload },
  ) => {
    return { ...state, ...payload };
  }),
  [CRSReserveDetailAction.setLoadingStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isLoading: payload };
  }),
  [CRSReserveDetailAction.setInitStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isInit: payload };
  }),
};

export const reducerMapper = (state = initialState, action) => {
  const actionType = action.type;
  const reducer = reducerMap[actionType];
  if (typeof reducer === 'function') {
    return reducer(<ReducerState>state, action);
  }
  return state;
};

export const storeName = 'reserveDetail4CRS';
